import React from "react";
import TextInput from "../../Components/Inputs/TextInput";
import TextareaInput from "../../Components/Inputs/TextareaInput";
import ReactSelectInput from "../../Components/Inputs/ReactSelectInput";
import Switch from "../../Components/Inputs/Switch";
import ImageInput from "../../Components/Inputs/ImageInput";
import ReactMultiSelectInput from "../../Components/Inputs/ReactMultiSelectInput";
import CategoryCodes from "./CategoryCodes";
import NumberInput from "../../Components/Inputs/NumberInput";

export default function ({register, errors, control, data, watch}) {

  return (<>
      <Switch
        label="Status Switch"
        name="is_active"
        parentClasses="col-md-12 mt-10 active-notactive"
        register={register}
        errorMessage={errors?.is_active}
      />

      <ImageInput
        name="icon"
        label="Icon (Recomended: SVG)"
        parentClasses="col-xl-4 col-sm-12"
        classes="d-inline-block"
        id="IconUpload"
        register={register}
        control={control}
        errorMessage={errors?.icon}
      />

      <ImageInput
        name="image"
        parentClasses="col-xl-4 col-sm-5 offset-xl-0 offset-sm-1"
        classes="d-inline-block"
        id="imageUpload"
        register={register}
        control={control}
        errorMessage={errors?.image}
      />

      <ImageInput
        name="image_responsive"
        label="Image Responsive (Recomended: SVG)"
        parentClasses="col-xl-4 col-sm-5"
        classes="d-inline-block"
        id="imageResponsiveUpload"
        register={register}
        control={control}
        errorMessage={errors?.image_responsive}
      />

      <TextInput
        label="Name"
        name="name"
        parentClasses="col-md-12"
        register={register}
        required={true}
        errorMessage={errors?.name}
      />

      <TextareaInput
        label="Description"
        name="description"
        register={register}
        required={false}
        rows={3}
        event={true}
        eventName="Characters"
        watch={watch}
        errorMessage={errors?.description}
      />

      <TextareaInput
        label="Keywords"
        name="keywords"
        register={register}
        required={false}
        rows={3}
        event={true}
        watch={watch}
        errorMessage={errors?.keywords}
      />

      <div className="text-muted fs-7 mb-5">
          Set keywords to the category separated by comma ( ex: word1, word2, word3 )
      </div>

      <TextInput
        label="Code"
        name="code"
        register={register}
        errorMessage={errors?.code}
        readOnly={true}
      />

      <NumberInput
        label="Position"
        name="order_by"
        register={register}
        errorMessage={errors?.order_by}
      />

      <ReactSelectInput
        label="Parent Category (If has one)"
        name="parent_id"
        placeholder="Choose parent category"
        register={register}
        options={data?.categories}
        errorMessage={errors?.parent_id}
        control={control}
      />

      <ReactSelectInput
        label="Delivery provider"
        name="delivery_provider"
        placeholder="Choose delivery provider"
        options={data?.deliveryProviders}
        errorMessage={errors?.delivery_provider}
        control={control}
        inputClassName='mt-5'
      />

      <ReactMultiSelectInput
        label="Top Products"
        name="products"
        placeholder="Choose Products"
        parentClasses="mt-5"
        inputClassName="col-md-6"
        register={register}
        values={data?.products}
        errorMessage={errors?.data}
        control={control}
        required={true}
      />

      {data?.is_last && (<CategoryCodes {...{register, errors, control, data}} />)}
    </>);
}